// app/customs/aisupport/index.tsx
'use client';

import React from 'react';
import VoiceRecording from '@/customs/voicerecording';
import './index.css';
import axios from "axios";
import { useState } from "react";
import * as AuthContext from '@/utils/authcontext';
import * as Global from '@utils/global';
// import ReactDOM from "react-dom";
import WaitingSpinner from '@/customs/waitingspinner';


type Props = {
  // 相談支援GUID: string;
  // action_filters?: Record<string, any>;
  actionTemplate: string
  actionPkey:string
  onClose?: () => void; // ← 追加
};

const AiSupport: React.FC<Props> = (props) => {

  //alert(`リンクパラメータ: ${JSON.stringify(props.action_filters)}`);
  const [result, setResult] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { employeeGUID, employeeDomain } = AuthContext.useAuth();
  const [daichoTitle, setDaichoTitle] = useState("");

  React.useEffect(() => {

    // alert(
    //   JSON.stringify(
    //       {body_data: {
    //         actionTemplate: props.actionTemplate,
    //         actionPkey: props.actionPkey,
    //       }}
    //   )
    // );

    async function loadPerson() {
      try {
        const res = await axios.post<any>(`${Global.getApiBaseUrl()}/aisupport/get_title`,
          {

            base_interface: {
              user_guid: employeeGUID,
              user_domain: employeeDomain,
              ip_address: window.location.hostname,
              user_agent: navigator.userAgent,
            },
            body_data: {
              // 相談台帳GUID: props.actionPkey,
              actionTemplate: props.actionTemplate,
              actionPkey: props.actionPkey,
            }
          }
        );
        setDaichoTitle(res.data?.タイトル ?? "");
      } catch (err) {
        console.error("利用者情報の取得エラー:", err);
      }
    }
    if (props.actionPkey) {
      loadPerson();
    }
  }, [props.actionPkey, employeeGUID, employeeDomain]);


  React.useEffect(() => {
    async function updateRoomTitle() {
      if (!daichoTitle || !props.actionPkey) return;
      try {
        await axios.post(
          `${Global.getApiBaseUrl()}/voice_recording/update_mendan_room`,
          {

            base_interface: {
              user_guid: employeeGUID,
              user_domain: employeeDomain,
              ip_address: window.location.hostname,
              user_agent: navigator.userAgent,
            },
            body_data: {
              記録庫GUID: props.actionPkey,
              タイトル: GetDaichoTitle(),
            }

          }
        );
        console.log("📝 面談ルームタイトル更新:", daichoTitle);
      } catch (err) {
        console.warn("⚠️ タイトル更新失敗（致命的ではない）", err);
      }
    }
    updateRoomTitle();
  }, [daichoTitle, props.actionPkey, employeeGUID, employeeDomain]);

  function GetDaichoTitle(){
    return `面談記録：${daichoTitle}`
  }

  async function onGenerate() {

    const ok = window.confirm(
      "相談支援プラン生成を開始します。\n前回の支援プランのAI生成欄を上書きします。\n実行してよろしいですか？"
    );
    if (!ok) return; // キャンセルしたら中断
        
    setLoading(true);
    setError("");
    try {

      const fd = new FormData();
      fd.append("user_guid", employeeGUID ?? "");
      fd.append("user_domain", employeeDomain ?? "");
      fd.append("ip_address", window.location.hostname);
      fd.append("user_agent", navigator.userAgent);
      fd.append("pkey", props.actionPkey);
      fd.append("action_type", "AI-Support");
      fd.append("action_template", props.actionTemplate);
      // Excel Builder はバイナリ不要なので null → append しない
      const res = await axios.post<any>(
        `${Global.getApiBaseUrl()}/worker_push`,
        fd,
        { responseType: "blob" }
      );
      
      // 結果を UI に反映
      setResult(res.data?.result ?? "");
    } catch (err: any) {
      console.error("AI生成エラー:", err);
      setError(err?.response?.data?.detail ?? "AI生成に失敗しました");
    } finally {
      setLoading(false);
      alert("生成が完了しました。\n相談支援プランの台帳で結果をご確認ください。");
    }
  }

  return (
    <div className="aisupport-container">

      {loading && (
        <WaitingSpinner message="相談支援プランを生成しています…" />
      )}

      {props.onClose && (
        <div className='spread-title'>
          <div>
            <strong>{GetDaichoTitle()}</strong>
          </div>
          <button onClick={props.onClose}>閉じる</button>
        </div>
      )}
      {props.actionPkey ? (
        <>
          <table>
            <tbody>
              <tr>
                <td style={{ verticalAlign: "top" }} width="50%">
                    <VoiceRecording
                      //action_filters={props.action_filters}
                      //action_filters={{"記録庫GUID": "{props.action_filters?.['相談台帳GUID']}"}}
                      actionPkey={props.actionPkey}
                      // onClose={closeChild}
                    />
                </td>
                <td style={{ verticalAlign: "top" }} width="50%">
                  <div className="ai-support-box">
                    <div className='tool-button'>
                      <button disabled>質問候補を更新</button>
                    </div>
                    <div className='tool-button'>
                      <button className='tool-button' onClick={onGenerate} disabled={loading}>
                        {loading ? "生成中..." : "支援プラン生成"}
                      </button>
                    </div>
                    {error && (
                      <div style={{ color: "red", marginTop: "8px" }}>{error}</div>
                    )}

                    <pre className="ai-result-area" style={{ whiteSpace: "pre-wrap" }}>
                      {result}
                    </pre>
                  </div>

                  <div className='kb31-21-check-title'>🟩以下は質問チェック項目の候補リストです。質問出来たら☑印を入れてください。</div>
                  <div className="kb31-21-checklist">
                    <label><input type="checkbox" name="chk_seiikureki" /> 生育歴</label>
                    <label><input type="checkbox" name="chk_shoshinkeii" /> 初診経緯</label>
                    <label><input type="checkbox" name="chk_seikatsureki" /> 生活歴</label>
                    <label><input type="checkbox" name="chk_genjo_shojo" /> 現状症状</label>
                    <label><input type="checkbox" name="chk_shigoto_shokureki" /> 仕事職歴</label>
                    <label><input type="checkbox" name="chk_kazoku_kankei" /> 家族関係性</label>
                    <label><input type="checkbox" name="chk_komarigoto" /> 困り事</label>
                    <label><input type="checkbox" name="chk_kadai" /> 課題</label>
                    <label><input type="checkbox" name="chk_honnin_ikou" /> 本人意向</label>
                    <label><input type="checkbox" name="chk_service_naiyou" /> サービス内容</label>
                    <label><input type="checkbox" name="chk_shien_jiki" /> 支援時期</label>
                    <label><input type="checkbox" name="chk_nyuuin_shokureki" /> 入院歴と職歴</label>
                    <label><input type="checkbox" name="chk_shoken_honnin_kibou" /> 初見本人希望</label>
                    <label><input type="checkbox" name="chk_shoken_kazoku_kibou" /> 初見家族希望</label>
                  </div>
                  <div className='kb31-21-check-title'>🟩面談のAI解析の品質を上げる注意事項</div>
                  <div className='kb31-21-check-title'>
                  ・文章の解釈の精度を上げるには、相手に「こういう解釈でいいですか？」と尋ね返すのが有効です<br />
                  </div>
                  <div className='kb31-21-check-title'>
                  {/* 🟥このページを参照できる人の観点（一般論としてのメモ）<br />
                  ・生の会話記録は推論の元データであり、相談する対象者と、支援員による信頼で成立。<br />
                  　これは１対１の信頼関係によるもので。会社に全てを話しているのではない。<br />
                  　生会話を参照できる人、再推論を実行できる人は、本人に限るようにすべきかも。<br />
                  ・全ての質問内容を第三者が閲覧できる仕組みの観点<br />
                  　デメリット：踏み込んだ質問をしようとしても、聞くのをためらうかもしれない。<br />
                  　メリット：踏み込みすぎた質問の抑止、標準的な質問に留める線引きを意識できる。<br /> */}
                  {/* ・AIの推論挙動の評価・検証の為、原田は見ることができる。<br />
                  　どのような会話でどんな推論を行ったか検証する為でありその為だけに確認する。<br />
                  　どのような質問が必要か、学習データとする。<br /> */}


                  </div>

                  {/* 🟩質問事項の候補<br />
                  🟩質問事項の候補<br />
                  ・会話の内容をリアルタイムに解析しお勧めの質問を随時候補順に表示する<br />
                  ・話し方にAI人格の差ができるようにしてもよい<br />
                  ・将来的にはここを読み上げするAIができると無人面談が可能になる<br />
                  ・面談パターンは、辞書によって必要な会話を定義し種類を増やしたい<br />
                  ・まずは人格を一人として、将来的に複数人格を表示するか<br />
                  🟩幼少期の質問<br />
                  ・<br />
                  ・<br />
                  🟩家族間について質問<br />
                  ・<br />
                  ・<br />
                  <br />
                  🟩IT・データ分野での使われ方<br />
                  ・spreadsheet（スプレッドシート）<br />
                  　→ データが“広がって”並ぶ表形式。つまり、行列の「展開」そのもの<br />
                  ・spread component / data spread<br />
                  　→ データを「レイアウトに展開する」意味でよく使われる<br />
                  　UIや帳票では、「spread」は、「データを可視レイアウトに展開する」というニュアンス<br /> */}
                  ・<br />
                  ・<br />
                </td>
              </tr>
            </tbody>
          </table>

        </>







      ) : (
        <p>面談GUIDが指定されていません</p>
      )}


    </div>
  );
};

export default AiSupport;
